/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ resource: NonNullable<unknown> }} Select_PlacesInputs */



/**
* | resource | output |
* | --- | --- |
* | "airHandlerUnit" | "Select units" |
* | "network" | "Select networks" |
* | "room" | "Select rooms" |
* | * | "Select rooms" |
*
* @param {Select_PlacesInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const select_places = /** @type {((inputs: Select_PlacesInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Select_PlacesInputs, { locale?: "fr" | "en" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") {
		if (i?.resource === "airHandlerUnit") return /** @type {LocalizedString} */ (`Select units`);
		if (i?.resource === "network") return /** @type {LocalizedString} */ (`Select networks`);
		if (i?.resource === "room") return /** @type {LocalizedString} */ (`Select rooms`);
		return /** @type {LocalizedString} */ (`Select rooms`)
	}
	{
		if (i?.resource === "airHandlerUnit") return /** @type {LocalizedString} */ (`Sélectionner des équipements`);
		if (i?.resource === "network") return /** @type {LocalizedString} */ (`Sélectionner des réseaux`);
		if (i?.resource === "room") return /** @type {LocalizedString} */ (`Sélectionner des pièces`);
		return /** @type {LocalizedString} */ (`Sélectionner des pièces`)
	}
});